import { useState, useEffect } from "react"
import { useForm } from "react-hook-form"
import { useMediaQuery } from "@mobi/hooks"

import removeSpecialChars from "@mobi/utils/formatters/removeSpecialChars"

import useFormPersist from "./useFormPersist"

const useHeader = () => {
  const [currentForm, setCurrentForm] = useState("branch")
  const [toggle, setToggle] = useState(false)
  const [togglePersist, setTogglePersist] = useState(true)
  const toggleDropDown = () => setToggle(!toggle)
  const isTablet = useMediaQuery("1024")

  const outsideToggleDropDown = (ev) => {
    if (
      ev.target.classList.contains("container") ||
      (ev.target.classList.contains("header") && window.innerWidth > 768)
    ) {
      setToggle(false)
    }
  }

  useEffect(() => {
    if (!isTablet) setToggle(false)    
  }, [isTablet])

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    control,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    shouldUnregister: true,
  })

  useFormPersist({ watch, setValue, togglePersist })

  const handlePersist = (ev) => {
    setTogglePersist(ev.target.checked)
  }

  const handleForm = (ev) => {
    setToggle(!toggle)
    setCurrentForm(ev.target.dataset.form)
  }

  const toggleSiblings = (show) => {
    let siblings = []
    const elem = document.querySelector(".ds-header")

    if (!elem.parentNode) {
      return siblings
    }

    let sibling = elem.parentNode.firstElementChild

    do {
      if (sibling != elem) {
        siblings.push(sibling)
      }
    } while ((sibling = sibling.nextElementSibling))

    siblings.forEach((elment) => {
      if (show) {
        elment.style.display = "none"
      } else {
        elment.style = {}
      }
    })

    return siblings
  }

  const onSubmitForm = (data) => {
    const keys = Object.keys(data)

    const dataSets = {
      branch: "data-branch",
      operatorCode: "data-operator-code",
      creditCard: "data-credit-card",
      documentNumber: "data-document-number",
    }

    keys.forEach((key) => {
      setTimeout(() => {
        if (key == "account") {
          const splitKey = data[key].split("-")
          document.querySelector(`[data-${key}]`).value = `${splitKey[0]}`
          document.querySelector(`[data-acc]`).value = `${splitKey[1]}`
        } else {
          document.querySelector(`[${dataSets[key]}]`).value =
            removeSpecialChars(data[key])
        }
        document.querySelector(`#submitformLogin`).click()
      }, 50)
    })
  }

  useEffect(() => {
    document.addEventListener("click", outsideToggleDropDown)

    return () => document.removeEventListener("click", outsideToggleDropDown)
  }, [])

  return {
    handleForm,
    toggleDropDown,
    handlePersist,
    register,
    handleSubmit,
    setValue,
    watch,
    onSubmitForm,
    currentForm,
    toggle,
    togglePersist,
    errors,
    isDirty,
    isValid,
    control,
    toggleSiblings,
  }
}

export default useHeader
